import { ExternalPaymentType as ExternalPaymentTypeEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ExternalPaymentType() {}

const config = {
    Unspecified: 0,
    BadDebts: 1,
    Bacs: 2,
    WireTransfer: 3,
    Invoice: 4,
    ExchangeRateDifference: 5,
    Complimentary: 6,
    Reseller: 7,
    ExchangeRoundingDifference: 8,
    Barter: 9,
    Commission: 10,
    BankCharges: 11,
    CrossSettlement: 12,
    Cash: 13,
    CreditCard: 14,
    Prepayment: 15,
    Cheque: 16,
    Bancontact: 17,
    IDeal: 18,
    PayPal: 19,
    GiftCard: 20,
    LoyaltyPoints: 21,
    ChequeVacances: 22,
    OnlinePayment: 23,
    CardCheck: 24,
    PaymentHubRedirection: 25,
    Voucher: 26,
    MasterCard: 27,
    Visa: 28,
    Amex: 29,
    Discover: 30,
    DinersClub: 31,
    Jcb: 32,
    UnionPay: 33,
    Twint: 34,
    Reka: 35,
    LoyaltyCard: 36,
    PosDiningAndSpaReward: 37,
    DirectDebit: 38,
    DepositCheck: 39,
    DepositCash: 40,
    DepositCreditCard: 41,
    DepositWireTransfer: 42,
} satisfies Record<ExternalPaymentTypeEnum, number>;

type Keys = keyof typeof config;
enumify<Keys, number>(ExternalPaymentType, 'ExternalPaymentType', config);

export default ExternalPaymentType as unknown as Enumify<Keys, number>;
